const logoSrc = (file) => `${process.env.PUBLIC_URL}/img/logos/${file}`;

export const LOGOS = [
  {
    id: 'aapl',
    name: 'Apple',
    ticker: 'AAPL',
    src: logoSrc('AAPL.png'),
    marketCap: 3500,
    employees: 164000,
  },
  {
    id: 'msft',
    name: 'Microsoft',
    ticker: 'MSFT',
    src: logoSrc('MSFT.png'),
    marketCap: 3800,
    employees: 228000,
  },
  {
    id: 'meta',
    name: 'Meta',
    ticker: 'META',
    src: logoSrc('META.png'),
    marketCap: 1500,
    employees: 74000,
  },
  {
    id: 'tsla',
    name: 'Tesla',
    ticker: 'TSLA',
    src: logoSrc('TSLA.png'),
    marketCap: 1100,
    employees: 140000,
  },
  {
    id: 'nvda',
    name: 'NVIDIA',
    ticker: 'NVDA',
    src: logoSrc('NVDA.png'),
    marketCap: 4300,
    employees: 36000,
  },
  {
    id: 'amd',
    name: 'AMD',
    ticker: 'AMD',
    src: logoSrc('AMD.png'),
    marketCap: 280,
    employees: 26000,
  },
  {
    id: 'intl',
    name: 'Intel',
    ticker: 'INTC',
    src: logoSrc('INTL.png'),
    marketCap: 110,
    employees: 124800,
  },
];

export function shuffle(array) {
  const result = [...array];
  for (let i = result.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1));
    [result[i], result[j]] = [result[j], result[i]];
  }
  return result;
}
